import React from 'react';
import './ITOperationsOffer.css';
import a from './1.png';
import b from './2.png';
import c from './3.png';

const fitItems = [
    'עסקים בצמיחה שצריכים תשתית יציבה יותר.',
    'חברות עם פריסות ידניות ותהליכים לא מסודרים.',
    'עסקים עם ניטור חלקי או חוסר שליטה על סביבת הייצור.',
    'ארגונים עם עלויות ענן שגדלות בלי בקרה.',
    'חברות שצריכות חיבור טוב יותר בין פיתוח, תשתיות ופריסה.',
    'ארגונים בינוניים שצריכים הנהגה תפעולית ברורה בלי להעמיס עוד משרה מלאה.'
];

const problemItems = [
    'יש תקלות חוזרות בסביבת הייצור.',
    'פריסות עדיין נעשות ידנית או בחוסר סדר.',
    'קשה להבין מה קורה בזמן אמת.',
    'אין ניטור מספק ואין התראות אמינות.',
    'המערכת עובדת, אבל לא באמת בנויה לעומס או לצמיחה.',
    'עלויות ענן עולות בלי שליטה ברורה.',
    'יש תלות גבוהה מדי באדם אחד שמכיר את המערכת.',
    'כל שינוי קטן יוצר סיכון מיותר.'
];

const audienceSignals = [
    'אם אתם מרגישים שהתשתית הנוכחית כבר לא תומכת בקצב הצמיחה.',
    'אם יש לכם מערכת שעובדת, אבל אין מספיק שליטה, ניטור או אוטומציה.',
    'אם פריסות, תקלות ותחזוקה גוזלות יותר מדי זמן ואנרגיה.',
    'אם יש לכם צוות או ספקים, אבל אין מספיק הובלה תפעולית ברורה.',
    'אם אתם רוצים לעבור לענן, לשפר סביבה קיימת או לבנות תהליכים נכונים יותר.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הסביבה',
        text: 'ממפים את האתגרים, סביבת הייצור, תהליכי העבודה והיעדים העסקיים.'
    },
    {
        number: '02',
        title: 'ניתוח מצב קיים',
        text: 'בודקים תשתיות, פריסות, ניטור, סיכונים, עלויות ענן וצווארי בקבוק.'
    },
    {
        number: '03',
        title: 'בניית כיוון ברור לשיפור',
        text: 'מגדירים סדרי עדיפויות, תהליכים, אוטומציה וצעדים מעשיים לייצוב.'
    },
    {
        number: '04',
        title: 'ליווי ביישום ובהמשך',
        text: 'ממשיכים לייצב, לשפר ולהטמיע סטנדרטים בצורה שמחזיקה לאורך זמן.'
    }
];

const trustPoints = [
    'ניסיון בתשתיות, ענן, ניטור ותהליכי תפעול.',
    'גישה פרקטית שמחוברת לביצוע, לא רק להמלצות.',
    'חיבור בין פיתוח, תפעול וצרכים עסקיים.',
    'חשיבה על יציבות, תחזוקה וצמיחה כבר מההתחלה.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const ITOperationsOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-operations-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="it-operations-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">שירותי DevOps ותשתיות לעסקים שצריכים יציבות, שליטה ויכולת לצמוח</h2>
                        <p className="lead offer-description">
                            אנחנו עוזרים לעסקים לייצב תשתיות, לשפר תהליכי פריסה, להכניס
                            אוטומציה ולבנות סביבת ענן ותפעול שאפשר לסמוך עליה לאורך זמן.
                        </p>
                        <div className="ops-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאר פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row infrastructure-section align-items-center">
                    <div className="col-md-6">
                        <h3>DevOps נכון הוא לא רק ניהול שרתים</h3>
                        <p>
                            המטרה היא לבנות בסיס תפעולי יציב שמקטין סיכון, משפר תהליכי פריסה
                            ונותן יותר שליטה על סביבת הייצור.
                        </p>
                        <p>
                            עסקים רבים זזו מהר כדי לעלות לאוויר או לגדול. עכשיו הם צריכים יותר
                            יציבות, אוטומציה, משמעת תפעולית ותשתית שאפשר להמשיך איתה נכון.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={a} alt="אופטימיזציית תשתיות ויציבות תפעולית" className="img-fluid" />
                    </div>
                </div>

                <div className="row system-management-section align-items-center">
                    <div className="col-md-6">
                        <img src={b} alt="ניטור, אוטומציה וניהול תפעולי" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו משפרים תשתיות, מייצבים סביבות, בונים ניטור והתראות, מכניסים
                            אוטומציה ואורקסטרציה, ומשפרים תהליכי פריסה ושחרור גרסאות.
                        </p>
                        <p>
                            העבודה שלנו מחברת בין תשתיות, פיתוח וצרכים עסקיים כדי ליצור סביבת
                            עבודה ופריסה מסודרת שאפשר לסמוך עליה, לא רק לטפל בתקלות כשהן קורות.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">אופטימיזציית תשתיות ויציבות תפעולית</div>
                            <div className="signal-item">ניטור, התראות ונראות טובה יותר</div>
                            <div className="signal-item">אוטומציה ואורקסטרציה</div>
                            <div className="signal-item">שיפור תהליכי פריסה ושחרור גרסאות</div>
                            <div className="signal-item">סדר בנהלים, קונפיגורציה וסביבות</div>
                        </div>
                    </div>
                </div>

                <div className="row cloud-operations-section align-items-center">
                    <div className="col-md-6">
                        <h3>מה יוצא לכם מזה</h3>
                        <p>
                            תשתית יציבה יותר, פחות תקלות והשבתות, פריסות אמינות יותר ויותר שליטה
                            על מה שקורה בפרודקשן.
                        </p>
                        <p>
                            התוצאה היא פחות טעויות ידניות, תגובה טובה יותר לתקלות, בסיס נכון
                            לצמיחה ועלויות ענן שמנוהלות בצורה מסודרת יותר.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">פחות תקלות והשבתות</div>
                            <div className="signal-item">יותר נראות ושליטה על המערכת</div>
                            <div className="signal-item">פריסות מסודרות ואמינות יותר</div>
                            <div className="signal-item">חיסכון בזמן ובטעויות ידניות</div>
                            <div className="signal-item">פחות תלות באנשים בודדים</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={c} alt="ניהול ענן, פריסות וסקיילינג" className="img-fluid" />
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם הסביבה הנוכחית כבר לא נותנת לכם שקט, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך לייצב, לשפר או לבנות נכון יותר.
                            </p>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn mb-3"
                                onClick={scrollToForm}
                            >
                                השאר פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn mb-3"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                            <p className="cta-note mt-3">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ITOperationsOffer;
